// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"874737e2","977":"15a26682"}[chunkId] + ".chunk.js";
};